/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KinnserPatientInput } from './KinnserPatientInput';
import {
    KinnserPatientInputFromJSON,
    KinnserPatientInputFromJSONTyped,
    KinnserPatientInputToJSON,
    KinnserPatientInputToJSONTyped,
} from './KinnserPatientInput';

/**
 * 
 * @export
 * @interface CreateKinnserPatientRequest
 */
export interface CreateKinnserPatientRequest {
    /**
     * 
     */
    patient: KinnserPatientInput;
}

/**
 * Check if a given object implements the CreateKinnserPatientRequest interface.
 */
export function instanceOfCreateKinnserPatientRequest(value: object): value is CreateKinnserPatientRequest {
    if (!('patient' in value) || value['patient'] === undefined) return false;
    return true;
}

export function CreateKinnserPatientRequestFromJSON(json: any): CreateKinnserPatientRequest {
    return CreateKinnserPatientRequestFromJSONTyped(json, false);
}

export function CreateKinnserPatientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateKinnserPatientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'patient': KinnserPatientInputFromJSON(json['patient']),
    };
}

export function CreateKinnserPatientRequestToJSON(json: any): CreateKinnserPatientRequest {
    return CreateKinnserPatientRequestToJSONTyped(json, false);
}

export function CreateKinnserPatientRequestToJSONTyped(value?: CreateKinnserPatientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient': KinnserPatientInputToJSON(value['patient']),
    };
}

